import React, { useState } from "react";
import LoginV2Username from "../loginV2/loginV2Username";
import { Card, Col, Form, Row, Button } from "react-bootstrap";
import { VENDOR_LOGO } from "../../utils/data";
import LoaderSubmitButton from "../../utils/LoaderSubmitButton";
import { Spin } from "antd";
import axios from "axios";
import { ServiceUrl } from "../../utils/serviceUrl";
import { toast } from "react-hot-toast";
import { useHistory } from "react-router-dom";
import { queryParam } from "../../utils";
import UserNameInput from "./userNameInput";

import OtpVerify from "./otpVerify";
import NewPasswordInput from "./newPasswordInput";

const ForgotPassword = (props) => {
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const history = useHistory();

  const userParams = (field) => {
    let s = queryParam(props.location.search);
    if (s[field]) return s[field];
  };

  return (
    <div>
      <div className="container ">
        <Row style={{ marginTop: "6%" }}>
          <Col md={{ span: 4, offset: 4 }}>
            <Spin spinning={loader}>
              <Card>
                <Card.Body>
                  <div className="text-center">
                    <img
                      src={VENDOR_LOGO}
                      className="bg-white rounded-3 mb-3"
                      style={{ width: "120px" }}
                    />
                  </div>
                  <h5 className="fw-bold">Forgot Password</h5>

                  {!userParams("type") && <UserNameInput {...props} />}
                  {userParams("type") == "otp" && <OtpVerify {...props} />}
                  {userParams("type") == "password" && (
                    <NewPasswordInput {...props} />
                  )}
                </Card.Body>
              </Card>
            </Spin>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ForgotPassword;
